import { useState, useEffect } from "react";
import fixturesBg from "../../Assets/Images/header-background-red.png";
import pitch from "./assets/pitch.png";
import { format } from "date-fns";
import ShareOnSocial from "react-share-on-social";

export default function FixtureCard(props) {
  const [expanded, setExpanded] = useState(false);

  const [goal, setGoal] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [videoSrc, setVideoSrc] = useState("");

  const formattedDate = format(
    new Date(props.fixture.fixture_date),
    "do MMMM yyyy h:mmaaa"
  )
    .replace("AM", "am")
    .replace("PM", "pm");

  return (
    <>
      <div className="rounded-t-xl overflow-hidden text-white font-sans w-full shadow-lg min-h-10">
        {" "}
        <div className="h-[10px] w-full bg-red-500 rounded-t-md"></div>
        <div
          className="relative text-white uppercase font-bold text-xs sm:text-sm tracking-wide px-4 py-2 min-h-[75px] Kallisto_Bold"
          style={{
            backgroundImage: `url(${pitch})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {formattedDate}
          <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 translate-y-[50px] z-10 w-80 h-8">
            <svg
              viewBox="0 0 160 40"
              className="w-full h-full text-[#00001d]"
              preserveAspectRatio="none"
            >
              <path
                d="
      M0,40 
      L30,5 
      L130,5  
      L160,40
      H0
      Z  
    "
                fill="currentColor"
              />
            </svg>
            <div className="absolute top-[45%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white text-lg font-bold mt-10">
              <div className="flex items-center gap-2">
                <span className="text-4xl sm:text-7xl Kallisto_Bold mb-2">
                  {props.fixture.home.score}
                </span>{" "}
                <span className="text-xl">v</span>
                <span className="text-4xl sm:text-7xl Kallisto_Bold mb-2 text-amber-600">
                  {props.fixture.away.score}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-[#00001d] px-4 py-6 relative flex items-center justify-between text-center">
          <div className="text-xs sm:text-sm mt-1 Kallisto_Bold">
            {props.fixture.home.name}
          </div>

          <div className="text-xs sm:text-sm mt-1 Kallisto_Bold">
            {props.fixture.away.name}
          </div>
        </div>
        <a
          onClick={() => setExpanded(!expanded)}
          style={{
            backgroundImage: `url(${fixturesBg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          className="relative bg-[#d92c4b] px-4 py-2 text-white text-sm flex justify-between items-center rounded-b-xl cursor-pointer"
        >
          <div className="absolute inset-0 bg-red-500 opacity-50 pointer-events-none z-0 rounded-b-xl"></div>

          <div className="flex items-center gap-2 relative z-10">
            <span className="text-white text-lg">{expanded ? "▸" : "▾"}</span>
            <span className="uppercase font-bold text-xs tracking-wide Kallisto_Bold">
              Goal Highlights:
            </span>
          </div>

          <div className="bg-white bg-opacity-20 text-white text-xl w-6 h-6 flex items-center justify-center rounded-md font-bold relative z-10 Kallisto_Bold">
            {props.fixture.goals.length}
          </div>
        </a>
        {expanded && (
          <div className="bg-[#00001d] px-4 py-4 text-sm space-y-3 Kallisto_Bold">
            {props.fixture.goals.map((goal, index) => (
              <div
                key={index}
                className="flex items-center justify-between px-4 py-3 rounded-md hover:bg-[#0D1024] bg-transparent text-white"
              >
                <div className="w-[25%] flex items-center text-xs font-semibold">
                  <div className="uppercase text-gray-300">{index + 1}</div>
                </div>

                <div className="w-[25%] flex items-center justify-center text-2xl font-bold gap-1">
                  <span>{goal.home}</span>
                  <span>-</span>
                  <span className="text-[#8BF5B2]">{goal.away}</span>
                </div>

                <div className="w-[25%] flex justify-center">
                  <button
                    className="hover:text-gray-300 p-2"
                    onClick={() => {
                      setVideoSrc(goal.url);
                      setShowModal(true);
                    }}
                  >
                    <img
                      src={require("./assets/play.png")}
                      alt="Play"
                      className="w-6 h-6"
                    />
                  </button>
                </div>

                <div className="w-[25%] hidden sm:block text-sm font-semibold tracking-wide text-center">
                  DOWNLOAD CLIP
                </div>

                <a
                  href={goal.download}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-[20%] flex justify-center hidden sm:block"
                >
                  <button className="hover:text-gray-300 p-2">
                    <img
                      src={require("../../Assets/Images/download.png")}
                      alt="Download"
                      className="w-8 h-8"
                    />
                  </button>
                </a>

                <div className="block sm:hidden">
                  <ShareOnSocial
                    textToShare="Check out this goal"
                    link={goal.url}
                    linkTitle="Ballerz Goal Highlights"
                    linkMetaDesc="Watch this amazing goal from the Ballerz match!"
                    linkFavicon={"../../Assets/Images/download.png"}
                    noReferer
                  >
                    <button>Share</button>
                  </ShareOnSocial>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex items-center justify-center">
          <div className="p-4 w-[90%] max-w-4xl rounded-lg relative">
            <div className="flex justify-end mb-2">
              <button
                onClick={() => setShowModal(false)}
                className="text-white text-2xl font-bold hover:text-red-400"
              >
                ×
              </button>
            </div>

            <video
              src={videoSrc}
              controls
              autoPlay
              className="w-full rounded-md"
            ></video>
          </div>
        </div>
      )}
    </>
  );
}
